import { useState, type CSSProperties, type ReactNode } from 'react';
import { Icon } from '../../lib/icons.js';

/** Square (or round) artwork that fades in, with a tinted placeholder while loading or when missing. */
export function Artwork({
  src,
  size,
  round = false,
  icon = 'music',
  className = '',
  eager = false,
}: {
  src: string | null | undefined;
  size?: number | string;
  round?: boolean;
  icon?: string;
  className?: string;
  eager?: boolean;
}): ReactNode {
  const [state, setState] = useState<{ src: string | null | undefined; status: 'loading' | 'ok' | 'error' }>({ src, status: 'loading' });
  const status = state.src === src ? state.status : 'loading';
  const style: CSSProperties | undefined = size !== undefined ? { width: size, height: size } : undefined;
  return (
    <span className={`art ${round ? 'art-round' : ''} ${className}`} style={style} data-status={src ? status : 'error'}>
      {(!src || status !== 'ok') && (
        <span className="art-ph" aria-hidden="true">
          <Icon name={icon} size={typeof size === 'number' ? Math.max(14, Math.round(size * 0.32)) : 28} />
        </span>
      )}
      {src && status !== 'error' && (
        <img
          key={src}
          src={src}
          alt=""
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          draggable={false}
          onLoad={() => setState({ src, status: 'ok' })}
          onError={() => setState({ src, status: 'error' })}
        />
      )}
    </span>
  );
}
